import { APP_BASE_HREF, DatePipe } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NetworkInterceptorService } from './core/network-interceptor.service';
import { ExternalLibrariesModule } from './external-libraries/external-libraries.module';
import { FeatureModulesModule } from './feature-modules/feature-modules.module';
import { FormService } from './shared/common-services/form.service';
import { SharedModule } from './shared/shared.module';
import { UserAuthenticationModule } from './user-authentication/user-authentication.module';
import { JwtModule } from '@auth0/angular-jwt';
import { CoreModule } from './core/core.module';
import { environment } from 'src/environments/environment';
import { ExternalInitializationComponent } from './external-initialization/external-initialization.component';

export function tokenGetter() {
  return localStorage.getItem('token');
}
@NgModule({
  declarations: [
    AppComponent,
    ExternalInitializationComponent
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ExternalLibrariesModule,
    SharedModule,
    ReactiveFormsModule,
    UserAuthenticationModule,
    FeatureModulesModule,
    CoreModule,
    FormsModule,
    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetter
      }
    }),
  ],
  providers:
  [DatePipe, {
    provide: HTTP_INTERCEPTORS,
    useClass: NetworkInterceptorService,
    multi: true
  },
  { provide: APP_BASE_HREF, useValue: environment?.baseHref?.toString() },
  FormService, provideHttpClient(withInterceptorsFromDi())]
})
export class AppModule { }
